import {
  FETCH_INVENTORY,
  DELETE_INVENTORY,
  UPDATE_INVENTORY,
  CREATE_TEMPERATURE,
  ADD_TEMPERATURE_TO_INVENTORY,
  FETCH_ITEMS,
  FETCH_BRANDS,
  FETCH_GRADES,
  FETCH_WASTE_CATEGORIES,
  FETCH_LOCATIONS,
  FETCH_AUDITS,
  CREATE_AUDIT,
  FETCH_AUDIT,
  ADD_AUDIT_INVENTORY,
  REMOVE_AUDIT_INVENTORY,
  CSV_SUBMIT,
  FETCH_OFFERS,
  FETCH_INVENTORIES_RECALL,
} from "./types";
import * as API from "./api";

// --------------------------------------------------------------------------
// FETCH_INVENTORY
// --------------------------------------------------------------------------
export const fetchInventory = (id) => ({
  type: FETCH_INVENTORY.init,
  payload: API.fetchInventory(id),
});

export const fetchInventorySuccess = (data) => ({
  type: FETCH_INVENTORY.success,
  payload: data,
});

export const fetchInventoryFailure = (error) => ({
  type: FETCH_INVENTORY.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// DELETE_INVENTORY
// --------------------------------------------------------------------------
export const deleteInventory = (id, data) => ({
  type: DELETE_INVENTORY.init,
  payload: API.deleteInventory(id, data),
});

export const deleteInventorySuccess = (data) => ({
  type: DELETE_INVENTORY.success,
  payload: data,
});

export const deleteInventoryFailure = (error) => ({
  type: DELETE_INVENTORY.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// UPDATE_INVENTORY
// --------------------------------------------------------------------------
export const updateInventory = (id, data) => ({
  type: UPDATE_INVENTORY.init,
  payload: API.updateInventory(id, data),
});

export const updateInventorySuccess = (info) => ({
  type: UPDATE_INVENTORY.success,
  payload: info,
});

export const updateInventoryFailure = (error) => ({
  type: UPDATE_INVENTORY.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// CREATE_TEMPERATURE
// --------------------------------------------------------------------------
export const createTemperature = (data) => ({
  type: CREATE_TEMPERATURE.init,
  payload: API.createTemperature(data),
});

export const createTemperatureSuccess = (info) => ({
  type: CREATE_TEMPERATURE.success,
  payload: info,
});

export const createTemperatureFailure = (error) => ({
  type: CREATE_TEMPERATURE.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// ADD_TEMPERATURE_TO_INVENTORY
// --------------------------------------------------------------------------
export const addTemperatureToInventory = (data) => ({
  type: ADD_TEMPERATURE_TO_INVENTORY,
  payload: data,
});

// --------------------------------------------------------------------------
// FETCH_ITEMS
// --------------------------------------------------------------------------
export const fetchItems = (name, station, page) => ({
  type: FETCH_ITEMS.init,
  payload: API.fetchItems(name, station, page),
});

export const fetchItemsSuccess = (info) => ({
  type: FETCH_ITEMS.success,
  payload: info,
});

export const fetchItemsFailure = (error) => ({
  type: FETCH_ITEMS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_ITEMS (MARKET ORDER)
// --------------------------------------------------------------------------
export const fetchMarketItems = (name, station, page) => ({
  type: FETCH_ITEMS.init,
  payload: API.fetchMarketItems(name, station, page),
});

export const fetchMarketItemsSuccess = (info) => ({
  type: FETCH_ITEMS.success,
  payload: info,
});

export const fetchMarketItemsFailure = (error) => ({
  type: FETCH_ITEMS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_BRANDS
// --------------------------------------------------------------------------
export const fetchBrands = (includeVendorBrands, priceLists) => ({
  type: FETCH_BRANDS.init,
  payload: API.fetchBrands(includeVendorBrands, priceLists),
});

export const fetchBrandsSuccess = (info) => ({
  type: FETCH_BRANDS.success,
  payload: info,
});

export const fetchBrandsFailure = (error) => ({
  type: FETCH_BRANDS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_OFFERS
// --------------------------------------------------------------------------
export const fetchItemOffers = (id) => ({
  type: FETCH_OFFERS.init,
  payload: API.fetchItemOffers(id),
});

export const fetchItemOffersSuccess = (info) => ({
  type: FETCH_OFFERS.success,
  payload: info,
});

export const fetchItemOffersFailure = (error) => ({
  type: FETCH_OFFERS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_GRADES
// --------------------------------------------------------------------------
export const fetchGrades = () => ({
  type: FETCH_GRADES.init,
  payload: API.fetchGrades(),
});

export const fetchGradesSuccess = (info) => ({
  type: FETCH_GRADES.success,
  payload: info,
});

export const fetchGradesFailure = (error) => ({
  type: FETCH_GRADES.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_WASTE_CATEGORIES
// --------------------------------------------------------------------------
export const fetchWasteCategories = () => ({
  type: FETCH_WASTE_CATEGORIES.init,
  payload: API.fetchWasteCategories(),
});

export const fetchWasteCategoriesSuccess = (info) => ({
  type: FETCH_WASTE_CATEGORIES.success,
  payload: info,
});

export const fetchWasteCategoriesFailure = (error) => ({
  type: FETCH_WASTE_CATEGORIES.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_LOCATIONS
// --------------------------------------------------------------------------
export const fetchLocations = () => ({
  type: FETCH_LOCATIONS.init,
  payload: API.fetchLocations(),
});

export const fetchLocationsSuccess = (info) => ({
  type: FETCH_LOCATIONS.success,
  payload: info,
});

export const fetchLocationsFailure = (error) => ({
  type: FETCH_LOCATIONS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_AUDITS
// --------------------------------------------------------------------------
export const fetchAudits = (page) => ({
  type: FETCH_AUDITS.init,
  payload: API.fetchAudits(page),
});

export const fetchAuditsSuccess = (data) => ({
  type: FETCH_AUDITS.success,
  payload: data,
});

export const fetchAuditsFailure = (error) => ({
  type: FETCH_AUDITS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// CREATE_AUDIT
// --------------------------------------------------------------------------
export const createAudit = (data) => ({
  type: CREATE_AUDIT.init,
  payload: API.createAudit(data),
});

export const createAuditSuccess = (data) => ({
  type: CREATE_AUDIT.success,
  payload: data,
});

export const createAuditFailure = (error) => ({
  type: CREATE_AUDIT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_AUDIT
// --------------------------------------------------------------------------
export const fetchAudit = (id) => ({
  type: FETCH_AUDIT.init,
  payload: API.fetchAudit(id),
});

export const fetchAuditSuccess = (data) => ({
  type: FETCH_AUDIT.success,
  payload: data,
});

export const fetchAuditFailure = (error) => ({
  type: FETCH_AUDIT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// ADD_AUDIT_INVENTORY
// --------------------------------------------------------------------------
export const addAuditInventory = (data) => ({
  type: ADD_AUDIT_INVENTORY.init,
  payload: API.addAuditInventory(data),
});

export const addAuditInventorySuccess = (data) => ({
  type: ADD_AUDIT_INVENTORY.success,
  payload: data,
});

export const addAuditInventoryFailure = (data) => ({
  type: ADD_AUDIT_INVENTORY.failure,
  payload: data,
});

// --------------------------------------------------------------------------
// REMOVE_AUDIT_INVENTORY
// --------------------------------------------------------------------------
export const removeAuditInventory = (data) => ({
  type: REMOVE_AUDIT_INVENTORY.init,
  payload: API.removeAuditInventory(data),
});

export const removeAuditInventorySuccess = (data) => ({
  type: REMOVE_AUDIT_INVENTORY.success,
  payload: data,
});

export const removeAuditInventoryFailure = (data) => ({
  type: REMOVE_AUDIT_INVENTORY.failure,
  payload: data,
});

// --------------------------------------------------------------------------
// CSV_SUBMIT
// --------------------------------------------------------------------------
export const csvSubmit = (data) => ({
  type: CSV_SUBMIT.init,
  payload: API.csvSubmit(data),
});

export const csvSubmitSuccess = (data) => ({
  type: CSV_SUBMIT.success,
  payload: data,
});

export const csvSubmitFailure = (error) => ({
  type: CSV_SUBMIT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_INVENTORIES_RECALL
// --------------------------------------------------------------------------
export const fetchInventoriesRecall = (page, inventory_id, session_id, lot_id, shipment_id, plant_id, vendor) => ({
  type: FETCH_INVENTORIES_RECALL.init,
  payload: API.fetchInventoriesRecall(page, inventory_id, session_id, lot_id, shipment_id, plant_id, vendor),
});

export const fetchInventoriesRecallSuccess = (data) => ({
  type: FETCH_INVENTORIES_RECALL.success,
  payload: data,
});

export const fetchInventoriesRecallFailure = (error) => ({
  type: FETCH_INVENTORIES_RECALL.failure,
  payload: error,
});